/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/** @module SystemModule */

/**
 * Telemetry customer experience improvement program url.
 */
export const TELEMETRY_CEIP_URL = 'http://www.vmware.com/trustvmware/ceip.html';
